export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_17.ad34bf07.jpg";